<mat-form-field class="chips-cell" appearance="outline" (click)="input?.nativeElement.focus()">
  @if (label()) {
    <mat-label>{{ label() }}</mat-label>
  }
  <div class="chips-autocomplete">
    <mat-chip-grid #chipList>
      <div class="chips-autocomplete__display-block">
        @for (item of selectedItems(); let i = $index; track item.value) {
          <mat-chip-row class="chips-autocomplete__chip" (removed)="remove(item)">
            {{ item.name }}
            @if (!isDisabled()) {
              <button matChipRemove>
                <mat-icon class="chips-autocomplete__delete">cancel</mat-icon>
              </button>
            }
          </mat-chip-row>
        }
      </div>
      @if (!isDisabled()) {
        <div class="chips-autocomplete__input-container">
          <input
            class="chips-autocomplete__input"
            #input
            [placeholder]="label()"
            [formControl]="control"
            [matAutocomplete]="auto"
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes$ | async"
            (matChipInputTokenEnd)="onAdd($event)"
            (ngModelChange)="textChange.emit($event)"
          />
          @if (enableAdd()) {
            <button
              class="chips-cell__button"
              mat-icon-button
              (click)="addButton()"
              [disabled]="!control.value"
              matTooltip="Add"
            >
              <mat-icon>add_box</mat-icon>
            </button>
          }
          @if (tooltip()) {
            <mat-icon matSuffix [matTooltip]="tooltip()"> help </mat-icon>
          }
        </div>
        <mat-autocomplete
          #auto="matAutocomplete"
          (optionSelected)="onSelect($event)"
          (optionActivated)="optionActivated($event)"
        >
          @for (item of filteredItems(); track item.value) {
            <mat-option [value]="item.value">
              {{ item.name }}
            </mat-option>
          }
        </mat-autocomplete>
      }
    </mat-chip-grid>
  </div>
</mat-form-field>
